import { render, staticRenderFns } from "./ContactComplaint.vue?vue&type=template&id=640ab160&scoped=true&"
import script from "./ContactComplaint.vue?vue&type=script&lang=js&"
export * from "./ContactComplaint.vue?vue&type=script&lang=js&"
import style0 from "./ContactComplaint.vue?vue&type=style&index=0&id=640ab160&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ab160",
  null
  
)

export default component.exports